module.exports = __webpack_public_path__ + "img/airbnb.9f2e01ca.svg";